import PropTypes from 'prop-types';
import React, { Component } from 'react';

export default class RightLinks extends Component {
  render() {
    const { s, data, handleClickQuestion } = this.props;
    return (
      <div className={s.rightLinks}>
        <div className={s.title}>防控知识</div>
        <div className={s.docTip}>
          <div>
            <img src="/assets/images/icon/xj/ic_doctor.png" alt="" />
          </div>
          <ol>
            {data.map(({ title }) => (
              <li key={title} onClick={() => handleClickQuestion(title)}>
                {title}
              </li>
            ))}
          </ol>
        </div>
        <div className={s.divider} />
        <div className={s.title}>权威发布</div>
        <div className={s.links}>
          <div>
            <a
              href="http://2019ncov.chinacdc.cn/2019-nCoV/index.html"
              target="_blank"
              className={s.b0}
            >
              <img src="/assets/images/icon/xj/ic_dongtai.png" alt="" />
              <div>疫情动态</div>
            </a>
          </div>
          <div>
            <a
              className={s.b1}
              href="http://bmfw.www.gov.cn/ggjtmqjczcx/index.html"
              target="_blank"
            >
              <img src="/assets/images/icon/xj/ic_car.png" alt="" />
              <div>同乘查询</div>
            </a>
          </div>
          <div>
            <a
              className={s.b2}
              target="_blank"
              href="http://sousuo.gov.cn/s.htm?q=%E5%A4%8D%E5%B7%A5%E5%A4%8D%E4%BA%A7&t=zhengcelibrary&orpro="
            >
              <img src="/assets/images/icon/xj/ic_house.png" alt="" />
              <div>复工复产</div>
            </a>
          </div>
          <div>
            <a
              className={s.b3}
              target="_blank"
              href="http://bmfw.www.gov.cn/xxgzbdfyyqfkzsk/view/questionList.html"
            >
              <img src="/assets/images/icon/xj/ic_shenbao.png" alt="" />
              <div>防疫指南</div>
            </a>
          </div>
          <div>
            <a
              className={s.b4}
              target="_blank"
              href="http://bmfw.www.gov.cn/xxgzbdfyjycxjkzg/index.html"
            >
              <img src="/assets/images/icon/xj/ic_location.png" alt="" />
              <div>就医查询</div>
            </a>
          </div>
          <div>
            <a
              className={s.b5}
              href="https://mp.weixin.qq.com/s/e-FdTGq9hN-hmaFlql1WHg"
              target="_blank"
            >
              <img src="/assets/images/icon/xj/ic_phone.png" alt="" />
              <div>援助热线</div>
            </a>
          </div>
        </div>
        <div className={s.banner}>
          <a
            target="_blank"
            href="http://www.xinjiang.gov.cn/xinjiang/c100223/fkxxgzbdgz.shtml"
          >
            <img src="/assets/images/icon/xj/ic_banner.png" alt="" />
          </a>
        </div>
      </div>
    );
  }
}

RightLinks.propTypes = {
  s: PropTypes.shape().isRequired,
  handleClickQuestion: PropTypes.func.isRequired,
  data: PropTypes.array.isRequired,
};
